<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="userId" >
        <span slot="label" >
          <a-tooltip>
            用户id<template slot="title">用户id</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId"  :placeholder="$t('请输入')+'用户id'" />
      </a-form-model-item>
      <a-form-model-item prop="type" >
        <span slot="label" >
          <a-tooltip>
            账户类型，1:联盟佣金，2: 提现<template slot="title">账户类型，1:联盟佣金，2: 提现</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="isIncome" >
        <span slot="label" >
          <a-tooltip>
            是否收入<template slot="title">是否收入</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.isIncome"  :placeholder="$t('请输入')+'是否收入'" />
      </a-form-model-item>
      <a-form-model-item prop="amount" >
        <span slot="label" >
          <a-tooltip>
            金额<template slot="title">金额</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.amount"  :placeholder="$t('请输入')+'金额'" />
      </a-form-model-item>
      <a-form-model-item prop="beforeBalance" >
        <span slot="label" >
          <a-tooltip>
            变动前余额<template slot="title">变动前余额</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.beforeBalance"  :placeholder="$t('请输入')+'变动前余额'" />
      </a-form-model-item>
      <a-form-model-item prop="afterBalance" >
        <span slot="label" >
          <a-tooltip>
            变动后余额<template slot="title">变动后余额</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.afterBalance"  :placeholder="$t('请输入')+'变动后余额'" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            备注<template slot="title">备注</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUnionBalanceRecord, addUnionBalanceRecord, updateUnionBalanceRecord } from '@/api/union/unionBalanceRecord'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        type: null,

        isIncome: null,

        amount: null,

        beforeBalance: null,

        afterBalance: null,

        createTime: null,
        localeFieldMap:{},

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户id'+this.$t('不能为空'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: '账户类型，1:联盟佣金，2: 提现'+this.$t('不能为空'), trigger: 'change' }
        ],
        isIncome: [
          { required: true, message: '是否收入'+this.$t('不能为空'), trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '金额'+this.$t('不能为空'), trigger: 'blur' }
        ],
        beforeBalance: [
          { required: true, message: '变动前余额'+this.$t('不能为空'), trigger: 'blur' }
        ],
        afterBalance: [
          { required: true, message: '变动后余额'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        type: null,
        isIncome: null,
        amount: null,
        beforeBalance: null,
        afterBalance: null,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUnionBalanceRecord({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateUnionBalanceRecord(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addUnionBalanceRecord(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
